import { normalize, schema } from 'normalizr';
import { IState, ActionTypes } from './type';

const focusedPrioritySchema = new schema.Entity('focusedpriorities');
const focusedPriorityListSchema = [focusedPrioritySchema];

const initial: IState = {
  entities: {},
  ids: [],
  count: 0,
  loading: false,
  error: null
};

const reducer = (state: IState = initial, action: any) => {
  switch (action.type) {
    case ActionTypes.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case ActionTypes.SUCCESS: {
      const normalizedData = normalize(action.payload.results, focusedPriorityListSchema);

      return {
        ...state,
        entities: {
          ...state.entities,
          ...normalizedData.entities.focusedpriorities,
        },
        ids: normalizedData.result as string[],
        count: action.payload.count as number,
        loading: false
      };
    }

    case ActionTypes.SUCCESS_SINGLE: {
      const task = action.payload;
    
      return {
        ...state,
        entities: {
          ...state.entities,
          [task.id]: task
        },
        loading: false
      };
    }

    case ActionTypes.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

export default reducer;
